<template>
  <div class="questionnaire-container">
    <div class="questionnaire-header-container">
      <span class='title'>{{ questionnaireTitle }}</span>
    </div>
    <div
      v-for="(item, index) in questionnaireList"
      :key="index"
      class="question-container"
    >
      <div class='question-title-container'>
        <span class="label">{{ $t('hm.resume.question') }}</span>
        <span class="title">{{ item.title }}</span>
      </div>
      <div class="question-video-container" v-if="item.type===questionTypeVideo">
        <span class="label">{{ $t('hm.resume.video') }}</span>
        <div
          class='video-link'
          @click="handelVideoPop(item)"
          target="_blank">
          <img class="video-play-icon" :src="$DjangoStaticUrl('image/video/icon_video.png')" />
        </div>
      </div>
      <div class="question-attachment-container" v-if="item.type===questionTypeAttachment">
        <span class="label">{{ $t('hm.resume.attachment') }}</span>
        <a
          class="attachment-tag"
          target="_blank"
          :href="item.private_download_attname_url"
        >
          {{ $t('hm.btn.download') }}
        </a>
      </div>
      <div class="question-answer-container">
        <template v-if="item.type===questionTypeVideo || item.type===questionTypeAttachment">
          <span class="label">{{ $t('hm.resume.remark') }}</span>
        </template>
        <template v-else>
          <span class="label">{{ $t('hm.resume.answer') }}</span>
        </template>
        <span class="title">{{ item.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>

import { QUESTION_TYPE } from '@/constant/openQuestion'

export default {
  components: {
  },
  props: {
    questionnaireList: {
      require: true
    },
    questionnaireTitle: {
      require: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    questionTypeVideo () {
      return QUESTION_TYPE.VIDEO
    },
    questionTypeAttachment () {
      return QUESTION_TYPE.ATTACHMENT
    }
  },
  created () {
  },
  beforeDestroy () {

  },
  methods: {
    handelVideoPop (item) {
      this.$emit('videoPop', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.questionnaire-container {
  .questionnaire-header-container {
    padding: 10px 0 5px 10px;
    border-bottom: 1px solid #b4b4b4;

    .title {
      font-size: 20px;
      font-weight: 600;
    }
  }

  .question-container {
    margin: 20px 0;
    padding: 20px 10px;
    background-color: #FFFFFF;

    &> div {
      display: flex;
      align-items: center;
      font-size: 18px;
      margin: 10px 0;

      .label{
        width: 30%;
        font-size: 18px;
        text-align: right;
      }
    }

    .title {
      margin-left: 20px;
      width: 60%;
    }

    .question-video-container {
      display: flex;
      align-items: center;
      margin: 10px 0;

      .video-link {
        background-image: url($baseDomain + 'static/image/video/video_bg.png');
        background-size: 100% 100%;
        width: 120px;
        height: 50px;
        margin-left: 20px;
        display: flex;
        align-items: center;
        justify-content: center;

        .video-play-icon {
          height: 36px;
        }
      }
    }

    .question-attachment-container {
      display: flex;
      align-items: center;

      .attachment-tag {
        margin-left: 20px;
        color: #0096cc;
      }
    }
  }
}
</style>
